import { toast } from "react-toastify";

export const handleLogout = (navigate) => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("token_type");
    localStorage.removeItem("expires_in");
    localStorage.removeItem("user");
    localStorage.removeItem("isAuthenticated");

    toast.success("Déconnexion réussie!!");
    setTimeout(() => {
        window.location.href = "/";  // Forces full page reload
        // navigate("/");
    }, 1000);
};